/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: mojmir.studenovsky@eurowag.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Price,
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './';

/**
 * 
 * @export
 * @interface NegotiationOffer
 */
export interface NegotiationOffer {
    /**
     * 
     * @type {Price}
     * @memberof NegotiationOffer
     */
    price: Price;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationOffer
     */
    useJitpay?: boolean;
}

export function NegotiationOfferFromJSON(json: any): NegotiationOffer {
    return NegotiationOfferFromJSONTyped(json, false);
}

export function NegotiationOfferFromJSONTyped(json: any, ignoreDiscriminator: boolean): NegotiationOffer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'price': PriceFromJSON(json['price']),
        'useJitpay': !exists(json, 'useJitpay') ? undefined : json['useJitpay'],
    };
}

export function NegotiationOfferToJSON(value?: NegotiationOffer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'price': PriceToJSON(value.price),
        'useJitpay': value.useJitpay,
    };
}


